import { tryCatch } from './tryCatch.js';

const control = {
    tryCatch
};

export { control };
